'use client';

import React, { FC, useEffect, useState } from 'react';

import Loading from '@/components/Loading/loading';

// Works like the loader on production: it is visible only while the page HTML is still arriving,
// with no extra pause.
// - CSS (styles.scss) hides it as soon as the whole page (up to the footer) is in the document, before
//   any JS runs.
// - Browsers without CSS :has() hide it here, right after hydration.
// It is an overlay rendered into the server HTML, not a Suspense fallback: a Suspense boundary around
// the pages made notFound()/redirect() answer with 200.

// Client-side navigation and language switches (which remount the [lang] layout) do not show it again
let shownOnce = false;

const InitialLoader: FC = () => {
  const [visible, setVisible] = useState(!shownOnce);

  useEffect(() => {
    shownOnce = true;
    setVisible(false);
  }, []);

  return visible ? <Loading /> : null;
};

export default InitialLoader;
